/**
 * Opening an address in Google Maps.
 *
 * The documented universal URL rather than a `maps.google.com/?q=` guess: it
 * is the one Google supports across desktop and mobile, and on a phone it
 * hands off to the Maps app instead of opening a browser tab inside it — which
 * matters, because the person following this link is usually about to drive
 * there.
 *
 * Note what this is *not*: the Maps Platform API. No key, no billing, no
 * request. It is a link.
 */
export function mapsHref(parts: (string | null | undefined)[]): string | null {
  const query = parts.map((part) => part?.trim()).filter(Boolean).join(', ')
  if (!query) return null
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
}

/**
 * The attributes an address link needs, or nothing when there is no address.
 *
 * `noreferrer` as well as `noopener`: the target is a third party, and the
 * page somebody came from is nobody's business but theirs.
 */
export function mapsLink(parts: (string | null | undefined)[]): {
  href: string
  target: '_blank'
  rel: string
} | null {
  const href = mapsHref(parts)
  return href ? { href, target: '_blank', rel: 'noopener noreferrer' } : null
}
